export enum Position {
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  CENTER = 'center',
  LEFT = 'left',
  LEFT_TOP = 'left-top',
  RIGHT = 'right',
  RIGHT_TOP = 'right-top',
  TOP = 'top',
}

export type PositionCenter = 'center';
export type PositionTop = 'top';
export type PositionRight = 'right';
export type PositionBottom = 'bottom';
export type PositionLeft = 'left';
